import { VirtualizedListView } from "common/components/virtualized/virtualizedListView";

import { CategoryItemChild } from "./categoryItemChild";

export const CategoryItemList = VirtualizedListView.extend({
    className: "category-items virtualized",
    childView: CategoryItemChild,
    itemHeight: 33,
    childViewTriggers: {
        "treeitem:selected": "treeitem:selected"
    },
    childViewOptions() {
        return {
            temps: this.getOption("temps")
        };
    }
});
